"use client";
import TextArea from "@/components/views/add-place/TextArea";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import { useEffect, useState } from "react";
import { getOccupationDatas } from "../../../worker/DropdownApiReq";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useDataUpdater } from "@/lib/hooks/useApi";
import Dropdown from "@/components/Dropdown";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  handleNextStep: () => void;
}

const MAX_ABOUT_LENGTH = 20;

export default function CreateWorkerProfileFirstPart(props: Props) {
  const { handleNextStep } = props;
  const { t } = useTranslation();

  const [occupations, setOccupations]: any = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpenedDropdownService, setIsOpenedDropdownService] = useState(false);
  const [about, setAbout] = useState("");
  const [selectedOccupation, setSelectedOccupation] = useState({
    title: t("create-profile-occupation-placeholder"),
    id: 0,
  });

  useEffect(() => {
    const occupationsResponse = getOccupationDatas();

    occupationsResponse.then((r: any) => {
      setOccupations(r);
    });
  }, []);

  const { sendRequest } = useDataUpdater({
    auth: true,
    path: `trainer`,
    method: "POST",
    body: {
      occupationId: selectedOccupation.id,
      about: about,
    },
  });

  const handleSubmit = async () => {
    if (isDisabledButton()) return;

    setLoading(true);
    const response = await sendRequest().catch((res) => {
      setLoading(false);
      return res;
    });
    if (response == true) {
      setLoading(false);
      handleNextStep();
    }
  };

  const isDisabledButton = () => {
    return (
      loading || about.length < MAX_ABOUT_LENGTH || selectedOccupation.id == 0
    );
  };

  return (
    <>
      <div className="flex flex-col gap-4">
        <Dropdown title={selectedOccupation.title} parentClassName="w-full">
          {occupations.map((occ: { title: string; id: number }) => {
            return (
              <button
                role="button"
                key={occ.id}
                onClick={() => {
                  setSelectedOccupation(occ);
                  setIsOpenedDropdownService(false);
                }}
                className="py-2 px-2 rounded cursor-pointer flex justify-start w-full"
              >
                {occ.title}
              </button>
            );
          })}
        </Dropdown>

        <TextArea
          onChange={(e) => {
            setAbout(e.target.value);
          }}
          id="about-textarea"
          icon={<ArrowRightIcon className="size-5" />}
          placeholder={t("user-register-about-placeholder")}
          error={about.length < MAX_ABOUT_LENGTH}
          errorMessage={t("user-register-about-min-length-warning", {
            min: MAX_ABOUT_LENGTH,
          })}
        />
      </div>

      <Button
        disabled={isDisabledButton()}
        aria-disabled={isDisabledButton()}
        onClick={() => handleSubmit()}
        variant="accent"
        className={cn(`${isDisabledButton() ? "opacity-30" : "opacity-100"}`)}
      >
        <span className="text-center text-white text-sm font-bold font-['DM Sans']">
          Devam Et
        </span>
      </Button>
    </>
  );
}
